import { createFileRoute } from '@tanstack/react-router';

import { DmaStakeholdersPage } from '@/features/esg/dma/components/DmaStakeholdersPage';

export const Route = createFileRoute(
  '/_authenticated/esg/double-materiality/$assessmentId/stakeholders'
)({
  component: DmaStakeholdersRoute,
});

function DmaStakeholdersRoute() {
  const { assessmentId } = Route.useParams();
  return <DmaStakeholdersPage assessmentId={assessmentId} />;
}
